import { useTranslation } from 'react-i18next';
import { Tabs } from '@/components/ui/tabs';
import { useRoutedTabs } from '@/Pages/routedTabs';
import { MESSAGING_TABS } from '@/Pages/tabRoutes';
import TemplatesTab from './TemplatesTab';
import CampaignsTab from './CampaignsTab';
import SettingsTab from './SettingsTab';

/**
 * ADR-0026 — templates, campaigns, consent and quiet hours were headless
 * before this pass (17 routes, 4 file mentions). Consent itself lives on
 * the CRM side (`ConsentTab`, `SegmentMembersDialog` — ADR-0010) and is
 * reused here rather than redeclared; this screen is templates, campaigns
 * and the tenant-wide send controls (quiet hours, the weekly fatigue cap).
 */
export default function Messaging() {
  const { t } = useTranslation();
  const routed = useRoutedTabs('/messaging', MESSAGING_TABS);
  if (!routed.open) return routed.redirect;
  const { tabs, current, select } = routed;

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl font-semibold">{t('messaging.title')}</h1>
        <p className="text-sm text-ink-muted">{t('messaging.subtitle')}</p>
      </div>

      <Tabs
        tabs={tabs.map((entry) => ({ key: entry.id, label: t(entry.labelKey) }))}
        value={current}
        onChange={select}
        label={t('messaging.title')}
        idPrefix="messaging"
        className="scrollbar-thin gap-x-5 overflow-x-auto"
      />

      {current === 'templates' && <TemplatesTab />}
      {current === 'campaigns' && <CampaignsTab />}
      {current === 'settings' && <SettingsTab />}
    </div>
  );
}
